import { call, put } from "redux-saga/effects";
import {
  fetch_patient_data_failure,
  fetch_chat_patient,
  check_user_data_success,
  check_user_data_failure,
  check_user_data_request,
  signup_user_data_request,
  signup_user_data_success,
  signup_user_data_failure,
  add_patient_data_request,
  add_patient_data_success,
  add_patient_data_failure,
  login_user_data_failure,
  login_user_data_success,
  login_user_data_request,
  jwt_token,
  chatMessageAction,
  active_patients_failure,
  active_patients_request,
  active_patients_success,
  unclaimed_patients_failure,
  unclaimed_patients_request,
  unclaimed_patients_success,
  queued_patients_failure,
  queued_patients_request,
  queued_patients_success,
  other_patients_failure,
  other_patients_request,
  other_patients_success,
  loadChatUserIdPatientIdError,
  shiftActivePatientToTop,
  reorderUnClaimedPatient,
  loadChatUserIdPatientIdSuccess,
  updateOtherPatientsList,
  live_agent_chat_failure,
  live_agent_chat_request,
  live_agent_chat_success,
  shiftChatToTop,
} from "../actions";

import { urls } from "../constants/constants";
import * as SagaTypes from "./saga-types";
import * as Api from "../api";

/**** Search patient data function with searching parameter */
export function* findpatients(action) {
  try {
    const param_string = action.payload.param;
    const data = yield call(
      Api.post,
      `${urls.aspariaBackend}api/v1/patient/findPatients`,
      param_string
    );
    if (data) {
      action.callback(true, data);
    }
  } catch (e) {
    action.callback(false, e);
  }
}

export const searchPatients = (param, callback) => ({
  type: SagaTypes.FETCH_PATIENTS,
  payload: { param },
  callback,
});

/**** Search patient data function with searching parameter */
export function* findMorepatients(action) {
  try {
    const param_string = action.payload.param;
    const data = yield call(
      Api.post,
      `${urls.aspariaBackend}api/v1/patient/pagination`,
      param_string
    );
    if (data) {
      action.callback(true, data);
    }
  } catch (e) {
    action.callback(false, e);
  }
}

export const searchMorePatients = (param, callback) => ({
  type: SagaTypes.FETCH_MORE_PATIENTS,
  payload: { param },
  callback,
});

/*** Fetch patient for chat */
export function* fetchChatPatient(action) {
  try {
    if (action) {
      yield put(fetch_chat_patient(action));
    }
  } catch (e) {}
}

export const chatpatient = (param) => ({
  type: SagaTypes.FETCH_CHAT_PATIENT,
  param,
});

export function* getUsers(action) {
  yield put(check_user_data_request());
  try {
    const param_string = action.payload.param;

    const data = yield call(
      Api.post,
      `${urls.aspariaBackend}api/v1/user/checkUser`,
      {
        userName: param_string.username,
        id: param_string.id,
        // userId: param_string.id,
        practiceId: param_string.practiceId,
      }
    );
    if (data) {
      yield put(check_user_data_success(data));
    } else {
      yield put(check_user_data_failure());
    }
  } catch (e) {
    yield put(check_user_data_failure(e));
  }
}

export const checkUserExist = (param) => ({
  type: SagaTypes.CHECK_USER,
  payload: { param },
});

/**** add user data */
export function* signUpUser(action) {
  yield put(signup_user_data_request());
  try {
    const param_string = action.payload.param;
    const data = yield call(
      Api.post,
      `${urls.aspariaBackend}/api/v1/user/signup/`,
      param_string
    );

    if (data) {
      yield put(signup_user_data_success(data));
    } else {
      yield put(signup_user_data_failure());
    }
  } catch (e) {
    yield put(signup_user_data_failure(e));
  }
}

export const AddUser = (param) => ({
  type: SagaTypes.SIGNUP_USER,
  payload: { param },
});

/**** add patient data */
export function* addPatientData(action) {
  yield put(add_patient_data_request());
  try {
    const param_string = action.payload.param;
    const data = yield call(
      Api.post,
      `${urls.aspariaBackend}api/v1/patient`,
      param_string
    );
    if (data) {
      if (data.status === 400) {
        action.callback(data?.data?.success, data?.data?.message);
      }
      action.callback(data.data.data.data, data.data.data);
      yield put(add_patient_data_success(data.data.data));
    } else {
      yield put(add_patient_data_failure("error"));
    }
  } catch (e) {
    yield put(add_patient_data_failure(e));
  }
}

export const AddPatient = (param, cb) => ({
  type: SagaTypes.ADD_PATIENT,
  payload: { param },
  callback: cb,
});

/**
 * login user saga functions
 */
export const LoginSagaAction = (param) => {
  return {
    type: SagaTypes.LOGIN_USER,
    payload: { param },
  };
};

// login worker saga function
export function* loginSagaData(action) {
  yield put(login_user_data_request());
  try {
    const data = action.payload.param;
    if (data) {
      yield put(login_user_data_success(data));
    } else {
      yield put(login_user_data_failure("Something went wrong"));
    }
  } catch (e) {
    yield put(login_user_data_failure(e));
  }
}

/**
 * JWT SAGA worker and action
 */
export const jwtTokenAction = (token) => {
  return {
    type: SagaTypes.JWT_TOKEN_SAGA,
    payload: { token },
  };
};

export function* jwtTokenSagaData(action) {
  try {
    const data = action.payload.param;
    yield put(jwt_token(data));
  } catch (e) {}
}

/***
 * chat saga function for work and watcher
 */
export const chatMessageSagaAction = (chat) => {
  return {
    type: SagaTypes.CHAT_SAGA,
    payload: { chat },
  };
};

export function* chatSagaWorker(action) {
  try {
    const data = action.payload;
    yield put(chatMessageAction(data));
  } catch (e) {}
}

/***empty patient from reducer  */
export const emptyReducerAction = () => {
  return {
    type: SagaTypes.EMPTY_PATIENT,
  };
};

export function* emptyReducer() {
  yield put(fetch_patient_data_failure({}));
  yield put(chatMessageAction([]));
  yield put(add_patient_data_success({ data: [] }));
  yield put(loadChatUserIdPatientIdError("empty"));
  yield put(loadChatUserIdPatientIdSuccess([]));
}

/**
 * Fetch active patients
 *
 */
export function* activePatientsSaga(action) {
  let offset = action.payload.offset === undefined ? 0 : action.payload.offset;
  let status =
    action.payload.status === undefined ? "active" : action.payload.status;
  let search = action.payload.search || "";

  let tag = action.payload.tag ? action.payload.tag : "";

  yield put(active_patients_request());
  try {
    const result = yield call(
      Api.get,
      `${
        urls.aspariaBackend
      }api/v1/patient/getPatients?flag=${status}&pageNo=${offset +
        1}&pageSize=15&search=${encodeURIComponent(search)}&tag=${tag}`
    );
    if (result && result.data && result.data.data) {
      yield put(active_patients_success([...result.data.data]));
    } else {
      yield put(active_patients_success([]));
    }
  } catch (e) {
    yield put(active_patients_failure(e));
  }
}

export const activePatientSagaAction = (UserId) => {
  return {
    type: SagaTypes.FETCH_ACTIVE_PATIENTS,
    payload: UserId,
  };
};

/**
 * Fetch un-claimed patients
 */
export function* unclaimedPatientsSaga(action) {
  let offset = action.payload.offset === undefined ? 0 : action.payload.offset;
  let search = action.payload.search || "";

  yield put(unclaimed_patients_request());
  try {
    const result = yield call(
      Api.get,
      `${
        urls.aspariaBackend
      }api/v1/patient/getPatients?flag=unclaimed&pageNo=${offset +
        1}&pageSize=15&search=${search}`
    );
    if (result) {
      yield put(unclaimed_patients_success(result.data.data));
    } else {
      yield put(unclaimed_patients_success([]));
    }
  } catch (e) {
    yield put(unclaimed_patients_failure(e));
  }
}

export const unClaimedPatientSagaAction = (UserId) => {
  return {
    type: SagaTypes.FETCH_UNCLAIMED_PATIENTS,
    payload: UserId,
  };
};

/**
 * Fetch queued patients
 */
export function* queuedPatientsSaga(action) {
  let offset = action.payload.offset === undefined ? 0 : action.payload.offset;
  let search = action.payload.search || "";

  yield put(queued_patients_request());
  try {
    const result = yield call(
      Api.get,
      `${
        urls.aspariaBackend
      }api/v1/patient/getPatients?flag=queued&pageNo=${offset +
        1}&pageSize=15&search=${search}`
    );
    if (result) {
      yield put(queued_patients_success(result.data.data));
    } else {
      yield put(queued_patients_success([]));
    }
  } catch (e) {
    yield put(queued_patients_failure(e));
  }
}

export const queuedPatientsSagaAction = (UserId) => {
  return {
    type: SagaTypes.FETCH_QUEUED_PATIENTS,
    payload: UserId,
  };
};

/**
 * Fetch other patients
 */
export function* otherPatientsSaga(action) {
  const offset = action.payload.offset;
  let search = action.payload.search || "";

  yield put(other_patients_request());
  try {
    const result = yield call(
      Api.get,
      `${
        urls.aspariaBackend
      }api/v1/patient/getPatients?flag=others&pageNo=${offset +
        1}&pageSize=15&search=${search}`
    );
    if (result) {
      yield put(other_patients_success(result.data.data));
    } else {
      yield put(other_patients_success([]));
    }
  } catch (e) {
    yield put(other_patients_failure(e));
  }
}

export const otherPatientSagaAction = (UserId) => {
  return {
    type: SagaTypes.FETCH_OTHER_PATIENTS,
    payload: UserId,
  };
};

/**
 * shift user to top of the array
 */
export function* shiftPatientToTopSaga(action) {
  yield put(shiftActivePatientToTop(action.payload));
}

export const shiftPatientTopSagaAction = (arrayData) => {
  return {
    type: SagaTypes.SHIFT_PATIENT_TO_TOP_SAGA_TYPE,
    payload: arrayData,
  };
};

/**
 * re-order unclaimed user
 */
export function* reorderUnClaimedPatientsSaga(action) {
  yield put(reorderUnClaimedPatient(action.payload));
}

export const reorderUnClaimedPatientSagaAction = (arrayData) => {
  return {
    type: SagaTypes.REORDER_UNCLAIMED_PATIENTS_SAGA_TYPE,
    payload: arrayData,
  };
};

/**
 * Re-order queued users
 */

export const reorderQueuedPatientSagaAction = (arrayData) => {
  return {
    type: SagaTypes.REORDER_QUEUED_PATIENTS_SAGA_TYPE,
    payload: arrayData,
  };
};

/**
 * update list of other patients list
 */
export function* updateOtherListSaga(action) {
  yield put(updateOtherPatientsList(action.payload));
}

export const updateOthersPatientListSagaAction = (arrayData) => {
  return {
    type: SagaTypes.UPDATE_OTHER_PATIENT_LIST_TYPE,
    payload: arrayData,
  };
};

/**
 * Fetch and save all types of patient count
 */
export const PatientCountAction = () => {
  return {
    type: SagaTypes.GET_PATIENT_COUNT,
  };
};

export const save_patient_count = (data) => {
  return {
    type: SagaTypes.SAVE_PATIENT_COUNT,
    payload: data,
  };
};

export function* patientCount() {
  try {
    const result = yield call(
      Api.get,
      `${urls.aspariaBackend}api/v1/patient/count`
    );
    if (result) {
      yield put(save_patient_count(result.data.data));
    } else {
      yield put(save_patient_count({}));
    }
  } catch (e) {
    yield put(save_patient_count({}));
  }
}

/**
 * Fetch chats for liveAgent
 *
 */
export function* liveAgentChatSaga(action) {
  let offset = action.payload.offset === undefined ? 0 : action.payload.offset;
  let active = action.payload.active;
  let search = action.payload.search || "";

  yield put(live_agent_chat_request());
  try {
    const result = yield call(
      Api.get,
      `${
        urls.aspariaBackend
      }api/v1/livechat-agent/getClients?active=${active}&pageNo=${offset +
        1}&pageSize=15&search=${search}`
    );
    if (result && result.data && result.data.data) {
      yield put(live_agent_chat_success([...result.data.data]));
    } else {
      yield put(live_agent_chat_success([]));
    }
  } catch (e) {
    yield put(live_agent_chat_failure(e));
  }
}

export const liveAgentChatSagaAction = (obj) => {
  return {
    type: SagaTypes.FETCH_LIVE_AGENT_CHAT,
    payload: obj,
  };
};

/**
 * Fetch and save all types of live-agent patient count
 */
export const liveAgentChatCountAction = () => {
  return {
    type: SagaTypes.GET_CHAT_COUNT,
  };
};

export const save_chat_count = (data) => {
  return {
    type: SagaTypes.SAVE_CHAT_COUNT,
    payload: data,
  };
};

export function* liveAgentChatCount() {
  try {
    const result = yield call(
      Api.get,
      `${urls.aspariaBackend}api/v1/livechat-agent/count`
    );
    if (result) {
      yield put(save_chat_count(result.data.data));
    } else {
      yield put(save_chat_count({}));
    }
  } catch (e) {
    yield put(save_chat_count({}));
  }
}

/**
 * shift chat to top of the array
 */
export function* shiftChatToTopSaga(action) {
  yield put(shiftChatToTop(action.payload));
}

export const shiftChatTopSagaAction = (arrayData) => {
  return {
    type: SagaTypes.SHIFT_CHAT_TO_TOP_SAGA_TYPE,
    payload: arrayData,
  };
};

/**
 * Fetch and save notifications count
 */
export const notificationCountAction = () => {
  return {
    type: SagaTypes.GET_NOTIFICATION_COUNT,
  };
};

export const save_notification_count = (data) => {
  return {
    type: SagaTypes.SAVE_NOTIFICATION_COUNT,
    payload: data,
  };
};

export function* notificationCount() {
  try {
    const result = yield call(
      Api.get,
      `${urls.aspariaBackend}api/v1/notification/count`
    );
    if (result) {
      yield put(save_notification_count(result.data.data));
    } else {
      yield put(save_notification_count({}));
    }
  } catch (e) {
    yield put(save_notification_count({}));
  }
}
